import { Mods, mods } from '@approvalmax/theme';
import { Popup } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { WarningBlock } from 'modules/common/ui';
import { font, uAbsoluteFill, uFlexCenter } from 'modules/styles';
import styled from 'styled-components';

export const Warning = styled(WarningBlock)`
    padding-left: 40px;
    padding-right: 20px;
`;

export const LoadingBarContainer = styled.div`
    position: absolute;
    left: 0;
    top: 76px;
    right: 0;
    height: 4px;
`;

export const Content = styled.div`
    padding: 20px 60px 50px 80px;
`;

export const Root = styled(Popup.DefaultContent)`
    position: relative;
`;

export const DropZoneContainer = styled.section`
    position: relative;
`;

export const DropZoneOverlay = styled.div<StyledMods<Mods<'active'>>>`
    ${uAbsoluteFill()}
    ${font(16, '#4c8a5c')}
    display: none;

    ${mods.active.true`
            margin: 0 55px 45px 75px;
            background: #fff;
            ${uFlexCenter};
            border: 2px dashed #4c8a5c;
            border-radius: 5px;
        `}
`;

export const FileSection = styled.div`
    display: flex;
    margin: 30px 0 0 0;
`;
